import {DocumentPickerAsset} from 'expo-document-picker';
import {DocumentPicker} from '../api';
import {useAppDispatch} from '../store/hooks';
import {startOnboarding} from '../store/slices/upload';
import {Media} from '../types';
import uuid from 'react-native-uuid';
export function useClickFile() {
  const dispatch = useAppDispatch();
  const onClickFile = async (
    folderId: string,
    isEncoderProject: boolean,
    userId: string,
  ) => {
    console.info('file folderId', folderId);
    const pickerResult =
      (await DocumentPicker.pickSingle()) as DocumentPickerAsset & {
        file: File;
        type: string;
      };
    console.info('pickerResult', pickerResult);
    if (!pickerResult) return;
    const url = pickerResult.uri;
    const mimeType =
      pickerResult.file.type ||
      pickerResult.mimeType ||
      pickerResult.type;
    console.info('mimeType', mimeType);
    const nd: Media = {
      id: uuid.v4().toString(),
      url,
      title: pickerResult.name,
      originalId: pickerResult.name,
      filename: pickerResult.name,
      fileType: mimeType,
      folderId,
      userId,
      date: new Date().valueOf(),
      isMediaNew: !isEncoderProject,
      isEncoderProject,
      type: mimeType,
      size: pickerResult.file.size,
      extractor: 'local',
    };
    dispatch(startOnboarding({file: pickerResult.file, media: nd}));
  };
  return {
    onClickFile,
  };
}
